// extracted by mini-css-extract-plugin
export default {"chip":"FqSPQFqEKEYVPBaBgRQ0","chipActive":"VCJBQp3jYd9ImRw4inge","chipIcon":"Qw813qaZLeGR1F2amM1P","chipCaret":"oBamODwlEDLp7S5OYDKn","chipLabel":"dsSFhgVwmZvQwiDiaB7q"};